import './style.scss'
import { useContext, useEffect, useState } from 'react'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import {
    ScreenContainer, CustomContainer, AppSpan, AppText,
    AbsoluteContainer, FlexRow, GridContainer,
    Button, FlexColumn, Icon, Circle
} from 'src/style'
import CardIcon from 'src/assets/svg/card-icon-d2'
import UssdIcon from 'src/assets/svg/ussd-icon-d2'
import { cardDetails } from 'src/utils/mock-data'
import MastercardLogo from 'src/assets/img/mastercard-logo.svg'
import MastercardLogoDark from 'src/assets/img/mastercard-logo-dark.svg'
import GreenCardBg from 'src/assets/img/green-card-bg.svg'
import PurpleCardBg from 'src/assets/img/purple-card-bg.svg'
import cardMesh from 'src/assets/img/card-mesh.svg'
import cardWifi from 'src/assets/img/card-wifi.svg'
import DisableCardIcon from 'src/assets/svg/disable-card-icon-d2'
import ActivateCardIcon from 'src/assets/svg/activate-card-icon-d2'
import HotlistCardIcon from 'src/assets/svg/hotlist-card-icon-d2'
import RetrieveCardPinIcon from 'src/assets/svg/activate-card-icon-d2'
import { ReactComponent as EmailIcon } from 'src/assets/img/account-email.svg'
import { ReactComponent as EmbassyIcon } from 'src/assets/img/account-embassy.svg'
import { ReactComponent as OfficeIcon } from 'src/assets/img/account-office.svg'
import ApiContext from 'src/provider/API/call-service'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import {
    ActivateCardD2, CardRequestStatusD2, ComingSoon, DisableCard,
    FundWithCardD2, FundWithUssdD2, HotlistCardD2, RequestNewCardD2, StatementByEmailD2,
    StatementToEmbassyD2, StatementToThirdPartyD2
} from 'src/component'
import { Features, ICardDetails, InstitutionProfileDCardData } from 'src/model'
import { ReactComponent as NoDataIcon } from 'src/assets/img/no-data-icon-d2.svg'
import helpers from 'src/utils/helpers'
import { FiChevronRight } from 'react-icons/fi'

export const AccountD2: React.FC = () => {
    const { API } = useContext(ApiContext)
    const { notifier } = useContext(VisibilityContext)
    const { info: { theme, institutionData } } = useContext(AppInfoContext)
    const [navPosition, setNavPosition] = useState(0)
    const [dataForCard, setDataForCard] = useState<InstitutionProfileDCardData | null>(null)
    const [userCards, setUserCards] = useState<Array<ICardDetails> | null>(null)
    const [selectedCard, setSelectedCard] = useState<ICardDetails | null>(null)
    const [view, setView] = useState('')
    const hasCards = institutionData.featureIDs?.includes(Features.CARDS)

    console.log("cards", JSON.stringify(hasCards))

    useEffect(() => {
        if (navPosition === 28.5) fetchDataForCard()
    }, [navPosition])

    async function fetchDataForCard() {
        await fetchCustomerCards()
        fetchInstitutionInfoForCard()
    }

    async function fetchCustomerCards() {
        const response = await API.getCustomerCards()
        if (response) {
            setUserCards(response)
            if (response?.length === 1) setSelectedCard(response[0])
        }
    }

    async function fetchInstitutionInfoForCard() {
        const response = await API.getInstitutionInfoForCard()
        if (response) setDataForCard(response)
    }

    async function handleCardFeature(feature: string) {
        if (!selectedCard) return notifier.show('Kindly select the card you want to manage', 'Validation Response')
        setView(feature)
    }

    return (
        <>
            <ScreenContainer padding='2.5'>
                <CustomContainer
                    customRadius='10px 10px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                >
                    <CustomContainer>
                        <AppSpan textSize='2.2' fontWeight='700'>Account</AppSpan>
                        <AppText>Manage your Account, Fund Account, Card management and Statement.</AppText>
                    </CustomContainer>
                    <CustomContainer
                        className='scrollable-container'
                    >
                        <CustomContainer
                            topMargin="2" bottomMargin="2"
                            width={!hasCards ? '29.2' :'46.5' }
                            bgColor='#F4FFFE'
                            radius='0.5' height='4.5'
                        >
                            <AbsoluteContainer
                                width={!hasCards ? '28.2':navPosition === 0 ? '20' : navPosition === 28.5 ? '20' : '14'}
                                left={!hasCards? '0.5': navPosition === 0 ? '0.5' : navPosition === 28.5 ? '26' : '33'}
                                className='d3-toggled-wrapper'
                            >
                                <CustomContainer
                                    bgColor="#0EA59D" height="3.6" radius='0.6'
                                />
                            </AbsoluteContainer>
                            <FlexRow
                                zIndex="2" gap='2'
                                height='100' hUnit='%'
                                style={{ minWidth: 'fit-content' }}
                            >
                                {/* <GridContainer 
                                    height="100" hUnit='%'
                                    onClick={() => setNavPosition(0)}
                                >
                                    <AppSpan 
                                        fontWeight='600' cursor="pointer"
                                        color={navPosition === 0 ? "#ffffff" : "#667085"}
                                    >
                                        Fund Wallet
                                    </AppSpan>
                                </GridContainer> */}
                                <GridContainer
                                    height="4.5"
                                    onClick={() => setNavPosition(0)}
                                >
                                    <AppSpan
                                        fontWeight='600' cursor="pointer"
                                        color={navPosition === 0 ? "#ffffff" : "#667085"}
                                    >
                                        Account Statement
                                    </AppSpan>
                                </GridContainer>
                                {hasCards &&  <GridContainer
                                    height="4.5"
                                    onClick={() => institutionData.featureIDs?.includes(Features.CARDS) ? setNavPosition(28.5) : null}
                                >
                                    <AppSpan
                                        fontWeight='600' cursor="pointer"
                                        color={navPosition === 28.5 ? "#ffffff" : "#667085"}
                                    >
                                        Card Management
                                    </AppSpan>
                                </GridContainer>}
                               

                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                    {/*  { navPosition === 0 &&
                        // <CustomContainer>
                        //     <AppSpan>Fund your account with the following options</AppSpan>
                        //     <FlexRow
                        //         topMargin='1.5' justify-content='space-between'
                        //         alignItems='flex-start' gap='2'
                        //         className='d3-module-row-container'
                        //     >
                        //         <CustomContainer 
                        //             width='55' sizeUnit='%'
                        //             className='module-row-left-item'
                        //         >
                        //             <GridContainer 
                        //                 borderColor='#EAECF0'
                        //                 radius='0.8' minHeight='8' 
                        //                 bgColor={view === 'fund-with-card' ? '#F4FFFE' : '#ffffff'} 
                        //                 padding='2.5' topPadding='2' bottomPadding='2'
                        //                 onClick={() => setView('fund-with-card')}
                        //             >
                        //                 <FlexRow justifyContent='space-between' gap='1.5'>
                        //                     <FlexRow width='auto' sizeUnit='' gap='1.7'>
                        //                         <CardIcon />
                        //                         <CustomContainer width='auto' sizeUnit=''>
                        //                             <AppSpan fontWeight='600' color='#101828'>Fund with Card</AppSpan>
                        //                             <AppText color='#667085'>Add new card or use saved cards</AppText>
                        //                         </CustomContainer>
                        //                     </FlexRow>
                        //                     <FiChevronRight fontSize='1.7rem' color='#667085' />
                        //                 </FlexRow>
                        //             </GridContainer>
                        //             <GridContainer 
                        //                 borderColor='#EAECF0'
                        //                 radius='0.8' minHeight='8' 
                        //                 bgColor={view === 'fund-with-ussd' ? '#F4FFFE' : '#ffffff'} 
                        //                 padding='2.5' topPadding='2' bottomPadding='2'
                        //                 topMargin='2'
                        //                 onClick={() => setView('fund-with-ussd')}
                        //             >
                        //                 <FlexRow justifyContent='space-between' gap='1.5'>
                        //                     <FlexRow width='auto' sizeUnit='' gap='1.7'>
                        //                         <UssdIcon />
                        //                         <CustomContainer width='auto' sizeUnit=''>
                        //                             <AppSpan fontWeight='600' color='#101828'>Fund with USSD</AppSpan>
                        //                             <AppText color='#667085'>Dial Specific Bank codes to fund</AppText>
                        //                         </CustomContainer>
                        //                     </FlexRow>
                        //                     <FiChevronRight fontSize='1.7rem' color='#667085' />
                        //                 </FlexRow>
                        //             </GridContainer>
                        //         </CustomContainer>

                        //         { view === 'fund-with-card' &&
                        //             <FundWithCardD2
                        //                 close={() => setView('')} 
                        //             />
                        //         }
                        //         { view === 'fund-with-ussd' &&
                        //             <FundWithUssdD2
                        //                 close={() => setView('')}
                        //             />
                        //         }
                        //     </FlexRow>
                        // </CustomContainer>
                        <ComingSoon />
                    }
                    */}

                    {navPosition === 0 &&
                        <CustomContainer>
                            <AppSpan>Send statement with the following options</AppSpan>
                            <FlexRow
                                topMargin='1.5' justify-content='space-between'
                                alignItems='flex-start' gap='2'
                                className='d3-module-row-container'
                            >
                                <CustomContainer
                                    width='55' sizeUnit='%'
                                    className='module-row-left-item'
                                >
                                    <GridContainer
                                        borderColor='#EAECF0'
                                        radius='0.8' minHeight='8'
                                        bgColor={view === 'statement-by-email' ? '#F4FFFE' : '#ffffff'}
                                        padding='2.5' topPadding='2' bottomPadding='2'
                                        onClick={() => setView('statement-by-email')}
                                    >
                                        <FlexRow justifyContent='space-between' gap='1.5'>
                                            <FlexRow width='auto' sizeUnit='' gap='1.7'>
                                                <EmailIcon className='icon-component' />
                                                <AppText color='#101828' fontWeight='600' cursor='pointer'>Generate Account Statement</AppText>
                                            </FlexRow>
                                            <FiChevronRight fontSize='1.7rem' color='#667085' />
                                        </FlexRow>
                                    </GridContainer>
                                    {/* <GridContainer 
                                        borderColor='#EAECF0' topMargin='1.5'
                                        radius='0.8' minHeight='8'
                                        bgColor={view === 'statement-to-embassy' ? '#F4FFFE' : '#ffffff'} 
                                        padding='2.5' topPadding='2' bottomPadding='2'
                                        onClick={() => setView('statement-to-embassy')}
                                    >
                                        <FlexRow justifyContent='space-between' gap='1.5'>
                                            <FlexRow width='auto' sizeUnit='' gap='1.7'>
                                                <EmbassyIcon className='icon-component' />
                                                <AppText color='#101828' fontWeight='600' cursor='pointer'>Send to Embassy</AppText>
                                            </FlexRow>
                                            <FiChevronRight fontSize='1.7rem' color='#667085' />
                                        </FlexRow>
                                    </GridContainer>
                                    <GridContainer 
                                        borderColor='#EAECF0' topMargin='1.5'
                                        radius='0.8' minHeight='8'
                                        bgColor={view === 'statement-to-thirdParty' ? '#F4FFFE' : '#ffffff'} 
                                        padding='2.5' topPadding='2' bottomPadding='2'
                                        onClick={() => setView('statement-to-thirdParty')}
                                    >
                                        <FlexRow justifyContent='space-between' gap='1.5'>
                                            <FlexRow width='auto' sizeUnit='' gap='1.7'>
                                                <OfficeIcon className='icon-component' />
                                                <AppText color='#101828' fontWeight='600' cursor='pointer'>Send to Third Party</AppText>
                                            </FlexRow>
                                            <FiChevronRight fontSize='1.7rem' color='#667085' />
                                        </FlexRow>
                                    </GridContainer> */}
                                </CustomContainer>
                                {view === 'statement-by-email' &&
                                    <StatementByEmailD2
                                        close={() => setView('')}
                                    />
                                }
                                {view === 'statement-to-embassy' &&
                                    <StatementToEmbassyD2
                                        close={() => setView('')}
                                    />
                                }
                                {view === 'statement-to-thirdParty' &&
                                    <StatementToThirdPartyD2
                                        close={() => setView('')}
                                    />
                                }
                            </FlexRow>
                        </CustomContainer>
                    }

                    {navPosition === 28.5 &&
                        <CustomContainer>
                            {!!userCards?.length &&
                                <FlexRow gap='2.5' wrap='wrap' justifyContent='space-between' bottomMargin='2.5'>
                                    <AppText>Tap to select the card you want to manage</AppText>
                                    <FlexRow width='auto' sizeUnit='' gap='1.5' wrap='wrap'>
                                        <Button
                                            width='15.9' height='4'
                                            borderColor='#0D968F' hoverBgColor='#fff'
                                            hoverColor='#0D968F' titleSize='1.4'
                                            onClick={() => setView('request-new-card')}
                                        >
                                            Request New Card
                                        </Button>
                                        <Button
                                            width='17.2' height='4' bgColor="#ffffff"
                                            borderColor='#D0D5DD' hoverBgColor='#ffffff'
                                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                            onClick={() => setView('card-request-status')}
                                        >
                                            Card Request Status
                                        </Button>
                                    </FlexRow>
                                </FlexRow>
                            }

                            <GridContainer>
                                <CustomContainer
                                    className='scrollable-container account-cards-container'
                                >
                                    <FlexRow
                                        gap='2' justifyContent='center'
                                        style={{ minWidth: 'fit-content' }}
                                    >
                                        {
                                            userCards?.map((item: ICardDetails, index: number) => {
                                                let bgImg = index % 2 != 0 ? GreenCardBg : PurpleCardBg
                                                let color = '#ffffff' //index % 2 != 0 ? '#344054' : '#ffffff'
                                                let expiryDate = item.expiryDate ? helpers.getCardExpiryDate(item.expiryDate) : '00/00'

                                                return (
                                                    <CustomContainer
                                                        style={{ border: selectedCard?.cardPAN === item.cardPAN ? `3px solid ${theme['#0D968F']}` : 'none' }}
                                                        radius={selectedCard?.cardPAN === item.cardPAN ? '2' : '0'}
                                                        padding={selectedCard?.cardPAN === item.cardPAN ? '0.6' : '0'}
                                                        rightPadding={selectedCard?.cardPAN === item.cardPAN ? '1' : '0'}
                                                        key={index} width='auto' sizeUnit=''
                                                    >
                                                        <CustomContainer
                                                            width='31.7' radius='2' bgColor='#0D968F'
                                                            shadow='8.26243px 10.328px 16.5249px rgba(0, 0, 0, 0.05)'
                                                            onClick={() => setSelectedCard(item)}
                                                        >
                                                            {/* <AbsoluteContainer top='0' left='0' height='full' width='100' sizeUnit='%'>
                                                                <Icon src={bgImg} noResize minWidth='100' style={{objectFit: 'cover'}} />
                                                            </AbsoluteContainer> */}
                                                            <AbsoluteContainer bottom='0' left='0' width='100' sizeUnit='%'>
                                                                <Icon src={cardMesh} noResize minWidth='100' style={{ objectFit: 'cover' }} />
                                                            </AbsoluteContainer>
                                                            <AbsoluteContainer top='2' right='2'>
                                                                <CustomContainer width='2' height='2.4'>
                                                                    <Icon src={cardWifi} minWidth='100' />
                                                                </CustomContainer>
                                                            </AbsoluteContainer>

                                                            <FlexColumn
                                                                minHeight='20.2' justifyContent='space-between' padding='1.5'
                                                                alignItems='flex-start' topPadding='2' bottomPadding='2'
                                                                style={{ zIndex: '2' }}
                                                            >
                                                                <AppText textSize='1.65' fontWeight='600' color={color}>{institutionData?.name}</AppText>
                                                                <CustomContainer topMargin='2'>
                                                                    <FlexRow width='auto' sizeUnit='' gap='5' bottomMargin='0.5'>
                                                                        <AppSpan textSize='1.24' color={color} fontWeight='600' fontFamily="Manrope">{item?.nameOnCard}</AppSpan>
                                                                        <AppSpan textSize='1.24' color={color} fontWeight='600' fontFamily="Manrope">{expiryDate}</AppSpan>
                                                                    </FlexRow>
                                                                    <AppText textSize='1.65' color={color} fontWeight='600' fontFamily="Manrope">{item.cardPAN}</AppText>
                                                                </CustomContainer>
                                                                <AbsoluteContainer bottom='2' right='1'>
                                                                    <CustomContainer width='4.6' height='3.3'>
                                                                        <Icon src={index % 2 === 0 ? MastercardLogoDark : MastercardLogo} minWidth='100' />
                                                                    </CustomContainer>
                                                                </AbsoluteContainer>
                                                            </FlexColumn>
                                                        </CustomContainer>
                                                    </CustomContainer>
                                                )
                                            })
                                        }
                                    </FlexRow>
                                </CustomContainer>
                                {!!userCards?.length ?
                                    <>
                                        <FlexRow gap="1" topMargin="1.5" width='auto' sizeUnit=''>
                                            {userCards?.length >= 2 &&
                                                userCards?.map((item: any, index: number) => {
                                                    return (
                                                        <Circle size="1.14" bgColor="#0D968F" key={index} />
                                                    )
                                                })
                                            }
                                        </FlexRow>
                                        <FlexRow
                                            gap='1.5' width='auto' sizeUnit='' topMargin='1.5'
                                            className='acct-card-actions'
                                        >
                                            <GridContainer
                                                width='auto' sizeUnit=''
                                                onClick={() => handleCardFeature('disable-card')}
                                            >
                                                <DisableCardIcon className='icon-component' />
                                                <AppSpan textSize='1' topMargin='0.5' cursor='pointer'>Disable</AppSpan>
                                            </GridContainer>
                                            <GridContainer
                                                width='auto' sizeUnit=''
                                                onClick={() => handleCardFeature('activate-card')}
                                            >
                                                <ActivateCardIcon className='icon-component' />
                                                <AppSpan textSize='1' topMargin='0.5' cursor='pointer'>Activate</AppSpan>
                                            </GridContainer>
                                            <GridContainer
                                                width='auto' sizeUnit=''
                                                onClick={() => handleCardFeature('hotlist-card')}
                                            >
                                                <HotlistCardIcon className='icon-component' />
                                                <AppSpan textSize='1' topMargin='0.5' cursor='pointer'>Hotlist</AppSpan>
                                            </GridContainer>
                                            <GridContainer width='auto' sizeUnit=''>
                                                <RetrieveCardPinIcon className='icon-component' />
                                                <AppSpan textSize='1' topMargin='0.5' cursor='pointer'>Retrieve Pin</AppSpan>
                                            </GridContainer>
                                        </FlexRow>
                                    </>
                                    :
                                    <GridContainer minHeight='33.2' topMargin='2'>
                                        <CustomContainer width="auto" sizeUnit="">
                                            <GridContainer>
                                                <NoDataIcon className="icon-component" />
                                            </GridContainer>
                                            <AppText textSize="1.6" fontWeight="600" color="#101828" align="center" topMargin="1.5">
                                                No Card Record
                                            </AppText>
                                            <FlexRow width='auto' sizeUnit='' gap='1.5' topMargin='3' wrap='wrap' justifyContent='center' >
                                                <Button
                                                    width='15.9' height='4'
                                                    borderColor='#0D968F' hoverBgColor='#fff'
                                                    hoverColor='#0D968F' titleSize='1.4'
                                                    onClick={() => setView('request-new-card')}
                                                >
                                                    Request New Card
                                                </Button>
                                                <Button
                                                    width='17.2' height='4' bgColor="#ffffff"
                                                    borderColor='#D0D5DD' hoverBgColor='#ffffff'
                                                    hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                                    onClick={() => setView('card-request-status')}
                                                >
                                                    Card Request Status
                                                </Button>
                                            </FlexRow>
                                        </CustomContainer>
                                    </GridContainer>
                                }

                            </GridContainer>
                        </CustomContainer>
                    }


                </CustomContainer>
            </ScreenContainer>
            {view === 'request-new-card' &&
                <RequestNewCardD2
                    dataForCard={dataForCard}
                    close={() => setView('')}
                />
            }
            {view === 'card-request-status' &&
                <CardRequestStatusD2
                    close={() => setView('')}
                />
            }
            {view === 'disable-card' &&
                <DisableCard
                    close={() => setView('')}
                />
            }
            {view === 'activate-card' &&
                <ActivateCardD2
                    close={() => setView('')}
                />
            }
            {view === 'hotlist-card' &&
                <HotlistCardD2
                    close={() => setView('')}
                    card={selectedCard}
                    updateCardList={fetchCustomerCards}
                />
            }
        </>
    )
}
